//LOGO
export const LOGO = '/assets/svg/logo.svg'
export const BLACK_LOGO = '/assets/svg/logo_dark.svg'
export const SITE_NAME = 'The Chicago Wine Company'
